<button [disabled]="disabled"
        class="delete-btn"
        [ngClass]="{'disabled': disabled}"
        (click)="delete()">
  verwijder
</button>
